import VueSweetalert2 from 'vue-sweetalert2';
import Vue from 'vue'

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

Vue.use(VueSweetalert2, options)
